/* KONSEI draft cart: responsive AJAX add-to-bag and mini-cart refresh */
(function(){
'use strict';
const root=window.Shopify?.routes?.root||'/';
const money=n=>new Intl.NumberFormat('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0}).format((Number(n)||0)/100);
const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
let working=false;
async function api(url,options){
 const res=await fetch(root+url,{credentials:'same-origin',...options});
 const data=await res.json();if(!res.ok)throw Error(data.description||data.message||'Please try again');
 return data;
}
async function refresh(){
 const cart=await api('cart.js');
 const drawer=document.querySelector('#cart-drawer');if(!drawer)return cart;
 const title=drawer.querySelector('.cart-header>div');
 if(title)title.textContent='Your Shopping Bag ('+cart.item_count+')';
 document.querySelectorAll('[data-open-cart]').forEach(el=>{
  let counter=el.querySelector('.badge-count');
  if(!counter&&cart.item_count){counter=document.createElement('span');counter.className='badge-count';el.append(counter)}
  if(counter){counter.textContent=String(cart.item_count);counter.hidden=cart.item_count===0}
 });
 const body=drawer.querySelector('.cart-items-body');
 if(body){
  if(!cart.items.length){
   body.innerHTML='<div class="konsei-cart-empty"><h3>Your bag is empty</h3><p>Discover your next KONSEI ritual.</p><a class="btn btn-primary" href="/collections/all">Explore products</a></div>';
  }else{
   body.innerHTML=cart.items.map(item=>'<div class="cart-item-row">'+
     '<div class="cart-item-thumb">'+(item.image?'<img src="'+esc(item.image)+'" alt="'+esc(item.title)+'" loading="lazy">':'')+'</div>'+
     '<div class="ks-cart-entry"><a href="'+esc(item.url)+'">'+esc(item.product_title)+'</a>'+
     (item.variant_title&&item.variant_title!=='Default Title'?'<small>'+esc(item.variant_title)+'</small>':'')+
     '<strong>'+money(item.final_line_price)+'</strong>'+
     '<div class="qty-stepper"><button class="qty-btn" type="button" data-cart-qty="'+(item.quantity-1)+'" data-cart-key="'+esc(item.key)+'" aria-label="Decrease quantity">−</button>'+
     '<span class="qty-val">'+item.quantity+'</span>'+
     '<button class="qty-btn" type="button" data-cart-qty="'+(item.quantity+1)+'" data-cart-key="'+esc(item.key)+'" aria-label="Increase quantity">+</button></div></div>'+
     '<button class="ks-cart-remove" type="button" data-cart-qty="0" data-cart-key="'+esc(item.key)+'" aria-label="Remove item">Remove</button></div>').join('');
  }
 }
 const footer=drawer.querySelector('.cart-footer');
 if(footer){
  footer.hidden=!cart.items.length;
  if(cart.items.length)footer.innerHTML='<div class="konsei-cart-subtotal"><span>Subtotal</span><strong>'+money(cart.total_price)+'</strong></div>'+
   '<p style="font-size:.75rem;color:#67756d;margin:12px 0">Shipping and payment methods are confirmed at checkout.</p>'+
   '<a class="btn btn-primary" href="/checkout" style="width:100%;display:block;text-align:center;padding:14px">Secure checkout</a>'+
   '<a href="/cart" class="konsei-view-cart">View bag</a>';
 }
 return cart;
}
window.KONSEI=window.KONSEI||{};
window.KONSEI.refreshCart=refresh;
document.addEventListener('submit',async e=>{
 const form=e.target;
 if(!form.matches('form[data-konsei-card-form],form.konsei-product-form'))return;
 if(e.submitter?.name==='checkout')return;
 e.preventDefault();if(working)return;
 working=true;
 const btn=e.submitter||form.querySelector('[type="submit"]');
 const previous=btn?.innerHTML||'';
 if(btn){btn.disabled=true;btn.textContent='Adding…'}
 try{
  const result=await fetch(root+'cart/add.js',{method:'POST',body:new FormData(form),credentials:'same-origin'});
  const data=await result.json();
  if(!result.ok)throw Error(data.description||'Unable to add item');
  await refresh();if(window.KONSEI?.openCart)window.KONSEI.openCart();
  else window.location.href='/cart';
 }catch(err){alert(err.message||'Unable to add product')}
 finally{working=false;if(btn){btn.disabled=false;btn.innerHTML=previous}}
});
document.addEventListener('click',async e=>{
 const button=e.target.closest('[data-cart-key][data-cart-qty]');
 if(!button||working)return;
 e.preventDefault();working=true;button.disabled=true;
 try{
  await api('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:button.dataset.cartKey,quantity:Number(button.dataset.cartQty)})});
  await refresh();
 }catch(err){alert(err.message||'Unable to change quantity')}
 finally{working=false;button.disabled=false}
});
document.addEventListener('DOMContentLoaded',()=>{
 document.querySelectorAll('[data-open-cart]').forEach(btn=>btn.addEventListener('click',()=>{refresh().catch(()=>{})}));
});
})();